import React, { useEffect, useState } from "react";
import { useNavigate, NavLink, Link } from "react-router";
import { motion, AnimatePresence } from "motion/react";

import "./styles.css"; // Custom styles for the app
import { AirbudsYearlyHeader } from "./component/storyHeader";
import { isBeforeDate } from "./component/utils";
import { EmptyScreen } from "./validation/validation";
import { useData } from "./data/dataContext";

const MenuItem = ({ category, locked }) => {
  var lockedClassName = "locked";
  if (locked) {
    lockedClassName = "unlocked";
  }

  return (
    <div className={`menu-item ${lockedClassName}`}>
      <div className="menu-item-top">
        <div className="menu-item-day" key={category.id}>
          <h4>{category.weekDay}</h4>
          <p>
            {category.day}
            <sup>{category.sub}</sup>
          </p>
        </div>
        <div className={`locker ${lockedClassName}`} />
      </div>
      <p className="menu-item-category">{category.title}</p>
    </div>
  );
};

export const Menu = ({}) => {
  const { data } = useData();
  const [showBlocked, setShowBlocked] = useState(false);
  const [daysCategories, setDaysCategories] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    if (data == null) {
      return;
    }

    if (
      !data.top_artists &&
      !data.yingyang &&
      !data.weird_artist &&
      !data.compatible_friends
    ) {
      navigate("/stats");
    }
  }, [data]);

  useEffect(() => {
    var categories = [];

    if (!data) {
      return;
    }

    if (data.top_artists && data.top_artists.length > 0) {
      categories.push({
        id: "top-artist",
        weekDay: "Monday",
        day: "16",
        sub: "th",
        title: "Top Artist",
        route: "/artist",
        unlockDate: "2024-12-16T23:00:00",
      });
    }

    if (data.compatible_friends && data.compatible_friends.length >= 1) {
      categories.push({
        id: "most-compatible-friend",
        weekDay: "Tuesday",
        day: "17",
        sub: "th",
        title: "Music Match",
        route: "/compat",
        unlockDate: "2024-12-17T23:00:00",
      });
    }

    categories.push({
      id: "genre-validation",
      weekDay: "Wednesday",
      day: "18",
      sub: "th",
      title: "Get validated",
      route: "/validation",
      unlockDate: "2024-12-18T23:00:00",
    });

    if (data.yingyang || data.weird_artist) {
      categories.push({
        id: "artist-ranking",
        weekDay: "Thursday",
        day: "19",
        sub: "th",
        title: "Ghosted & Opposite Artists",
        unlockDate: "2024-12-19T23:00:00",
        route: "/curiosity",
      });
    }

    categories.push({
      id: "stats",
      weekDay: "Friday",
      day: "20",
      sub: "th",
      title: "All Stats",
      route: "/stats",
      unlockDate: "2024-12-20T23:00:00",
    });

    categories.push({
      id: "recomputed",
      weekDay: "January",
      day: "1",
      sub: "st",
      title: "Recomputed Recap",
      route: "/stats",
      unlockDate: "2025-01-01T23:00:00",
    });

    setDaysCategories(categories);
  }, [data]);

  if (!data) {
    return <EmptyScreen text="loading..." />;
  }

  return (
    <div className="app menu-app">
      <div className="content menu-content">
        <div className="menu-header">
          <img
            src={require("./assets/img/chrome2024.png")}
            alt="airbuds yearly recap"
          />
          <h1>Airbuds</h1>
          <h3>Yearly Recap</h3>
        </div>

        <div className="menu">
          {daysCategories.map((category, index) => {
            const unlocked = true;
            var lockedClassName = "locked";
            if (unlocked) {
              lockedClassName = "unlocked";
            }

            return (
              <button
                key={category.id}
                className={`menu-item-container ${lockedClassName}`}
                onClick={() => {
                  if (!unlocked) {
                    setShowBlocked(true);
                  } else {
                    navigate(category.route);
                  }
                }}
              >
                <MenuItem category={category} locked={unlocked} />
              </button>
            );
          })}
        </div>
      </div>

      {showBlocked && (
        <button onClick={() => setShowBlocked(false)}>
          <motion.div
            key="step-1"
            className="lock-modal"
            initial={{ opacity: 0, y: "200%" }}
            animate={{ opacity: 1, y: "50vh" }}
            exit={{ opacity: 1, y: "200%" }}
            transition={{
              duration: 0.5,
              delay: 0.0,
              ease: [0, 0.71, 0.2, 1.01],
            }}
          >
            <div class="locker">
              <p> </p>
            </div>
            <h1>Locked</h1>
            <p>Come back tomorrow to get a new Yearly stat!</p>
          </motion.div>
        </button>
      )}

      <AirbudsYearlyHeader hideMenuBanner={true} />
    </div>
  );
};
